<div class="flex flex-col flex-auto min-w-0">
  <!-- Main -->
  <div class="flex-auto p-6 sm:p-10">
    <!-- CONTENT GOES HERE -->
    <div class="h-180 min-h-180 max-h-180">
      <div class="flex flex-col mx-6 mt-3 rounded-md">
        <div class="grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 grid-cols-1 gap-4">
          <div>
            <button mat-raised-button class="capitalize">
              <input matInput [formControl]="searchKeywordFilter" placeholder="search" #input />
            </button>
          </div>
          <div class="flex justify-end">
            <button mat-raised-button class="capitalize" color="primary" (click)="openDialog()">
              <mat-icon svgIcon="heroicons_outline:user-group"></mat-icon>
              <span class="ml-2">Create Organisation</span>
            </button>
          </div>
        </div>
      </div>
      <div class="grid grid-cols-1 m-6 overflow-x-scroll rounded-lg">
        <table
          mat-table
          [dataSource]="dataSource"
          class="mat-elevation-z8"
          matSortActive="CREATED_AT"
          matSortDisableClear
          matSortDirection="desc"
          matSort
          #empTbSort="matSort"
        >
          <!--- Note that these columns can be defined in any order.
                          The actual rendered columns are set as a property on the row definition" -->

          <!-- logo Column -->
          <ng-container matColumnDef="logo">
            <th mat-header-cell *matHeaderCellDef>logo</th>
            <td mat-cell *matCellDef="let row" class="border-0">
              <img *ngIf="row.logoPath" class="rounded-full p-2" src="{{ row.logoPath }}" />
              <div class="ml-2">
                <ngx-avatar size="35" *ngIf="!row.logoPath" name="{{ row.name }}"></ngx-avatar>
              </div>
            </td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>name</th>
            <td mat-cell *matCellDef="let row" class="border-0">{{ row.name }}</td>
          </ng-container>

          <!-- Created Column -->
          <ng-container matColumnDef="created">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>createdAt</th>
            <td mat-cell *matCellDef="let row" class="border-0">{{ row.createdAt | date : 'medium' }}</td>
          </ng-container>
          <!-- actions -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="text-center">Actions</th>

            <mat-cell *matCellDef="let row; let i = index" class="border-0 flex justify-center items-center">
              <button mat-icon-button color="accent" (click)="viewOrganisationDetail(row.id)">
                <mat-icon svgIcon="heroicons_outline:eye"></mat-icon>
              </button>
              <button mat-icon-button color="primary" (click)="editOrganisation(i, row.id)">
                <mat-icon svgIcon="heroicons_outline:pencil"></mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="deleteOrganisation(row.id)">
                <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
              </button>
            </mat-cell>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" class="border-gray-200 border-b-[1px]"></tr>
        </table>
        <div *ngIf="!this.dataSource?.data.length" class="text-lg text-center">No Organisations</div>
        <mat-paginator
          #paginator
          [length]="totalData"
          [pageSizeOptions]="pageSizes"
          showFirstLastButtons
        ></mat-paginator>
      </div>
    </div>
  </div>
</div>
